import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../csscomponent/LegalPages.css';

const sections = [
  {
    title: 'Scope of Services',
    text: 'Services and Developer provides web design, custom development, optimization, and product engineering services including brochure-defined package deliverables.',
  },
  {
    title: 'User Responsibilities',
    text: 'Clients must provide accurate project requirements, legal rights to all submitted content, and timely approvals to avoid timeline delays.',
  },
  {
    title: 'Account and Access Security',
    text: 'Users creating Login/Signup accounts are responsible for password safety and any activity performed through their credentials.',
  },
  {
    title: 'Intellectual Property',
    text: 'Pre-existing tools, templates, and frameworks remain the property of their owners. Project-specific deliverables are transferred as defined in the engagement agreement.',
  },
  {
    title: 'Support and Maintenance',
    text: 'Post-launch support and maintenance are handled according to selected package scope and explicit support commitments.',
  },
  {
    title: 'Contact and Compliance',
    text: 'Legal or compliance concerns can be reported to the team via the contact channels listed in this website footer and service communications.',
  },
];

function Legal() {
  return (
    <section className="legal-page">
      <motion.div
        className="legal-hero"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
      >
        <p>Legal</p>
        <h1>Legal Information and Service Framework</h1>
        <span>
          This page summarizes the legal framework for engaging with Services and Developer across service pages,
          brochure content, product showcase content, and account flows.
        </span>
      </motion.div>

      <div className="legal-grid">
        {sections.map((section, index) => (
          <motion.article
            key={section.title}
            className="legal-card"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.08 }}
          >
            <h3>{section.title}</h3>
            <p>{section.text}</p>
          </motion.article>
        ))}
      </div>

      <div className="legal-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-service">Terms of Service</Link>
      </div>
    </section>
  );
}

export default Legal;
